<template>
    <div>
        <div class="animated revealUp">
            <div class="mb-3">
                <div class="section-title mb-3">{{ $t("transferStock") }}</div>
            </div>

            <div class="d-flex justify-content-between align-item-center mb-3"></div>
            <div class="white-wrapper">
                <div class="row">
                    <div class="col-12 col-md-3 mb-2">
                        <div class="dropdown-curve-container">
                            <label :class="dropDown.selectedCinemaId
                                ? 'shift-up'
                                : ''
                                ">{{ $t("select") }} {{ $tc("cinema", 1) }}</label>
                            <multiselect :options="getCinemasByRole" v-model="dropDown.selectedCinema"
                                :searchable="true" placeholder="" label="cine_name" track-by="cine_id"
                                @input="onSelectCinema($event)" :allowEmpty="false">
                            </multiselect>
                        </div>
                    </div>
                    <div class="col-12 col-md-2 mb-2">
                        <div class="d-flex align-items-center"><label class="mr-2">{{ $t("Transfer to Cinema")
                                }}</label>
                            <b-form-checkbox class="j-checkbox mb-1 pb-0" name="check-button"
                                v-model="toCinema"></b-form-checkbox>
                        </div>
                    </div>
                    <div class="col-12 col-md-3 mb-2">
                        <div class="dropdown-curve-container">
                            <label :class="selectedStore.sm_id
                                ? 'shift-up'
                                : ''
                                ">Select Store</label>
                            <multiselect :options="storeList" v-model="selectedStore" :searchable="true"
                                label="sm_store_name" track-by="sm_id" @input="onSelectStore()" :allowEmpty="false">
                            </multiselect>
                        </div>
                    </div>
                    <!-- Transfer to store -->
                    <div class="col-12 col-md-3 mb-2" v-if="!toCinema">
                        <div class="dropdown-curve-container">
                            <label :class="selectedToStore.sm_id
                                ? 'shift-up'
                                : ''
                                ">Select Store</label>
                            <multiselect :options="toStoreList" v-model="selectedToStore" :searchable="true"
                                label="sm_store_name" track-by="sm_id" :allowEmpty="false">
                            </multiselect>
                        </div>
                    </div>
                    <!-- Transfer to store -->

                    <!-- Transfer to cinemas -->
                    <div class="col-12 col-md-3 mb-2" v-if="toCinema">
                        <div class="dropdown-curve-container">
                            <label :class="dropDown.selectedCinemaId
                                ? 'shift-up'
                                : ''
                                ">{{ $t("select") }} {{ $tc("cinema", 1) }}</label>
                            <multiselect :options="getFilteredCinemas" v-model="selectedToCinema" :searchable="true"
                                placeholder="" label="cine_name" track-by="cine_id" :allowEmpty="false"
                                @select="onSelectToCinema($event)">
                            </multiselect>
                        </div>
                    </div>
                    <!-- To Store of Selected Cinema -->
                    <div class="col-12 col-md-3 mb-2" v-if="toCinema">
                        <div class="dropdown-curve-container">
                            <label :class="selectedToCinemaStore.sm_id
                                ? 'shift-up'
                                : ''
                                ">Select Store</label>
                            <multiselect :options="toCinemaStoreList" v-model="selectedToCinemaStore" :searchable="true"
                                label="sm_store_name" track-by="sm_id" :allowEmpty="false">
                            </multiselect>
                        </div>
                    </div>
                    <!-- To Store of Selected Cinema -->
                    <!-- Transfer to cinemas -->
                    <div class="col-12 col-md-3 mb-2">
                        <div class="dropdown-curve-container">
                            <label :class="selectedRawMaterialCategory.length > 0
                                ? 'shift-up'
                                : ''
                                ">Select Raw Material Category</label>
                            <multiselect v-model="selectedRawMaterialCategory" :options="rawMaterialCategory"
                                :searchable="true" :multiple="true" label="rmc_category" placeholder=""
                                track-by="rmc_id" :showLabels="false" @select="onSelectCategory('add', $event)"
                                @remove="onSelectCategory('remove', $event)"></multiselect>
                        </div>
                    </div>
                </div>
            </div>

            <!-- render raw materials based on category -->
            <div class="white-wrapper" v-if="rawMaterials.length">
                <section v-for="(rawMaterialCategoryObj, rawMaterialCategoryIndex) in rawMaterials"
                    :key="rawMaterialCategoryIndex + 'rawMaterialCategory'">
                    <!-- raw material category name -->
                    <div class="section-title mb-3 d-flex justify-content-between section-border"
                        v-b-toggle="rawMaterialCategoryObj.collapseCategoryName">
                        <span class="fs">{{ rawMaterialCategoryObj.category_name }}</span>
                        <button type="button" class="btn-transparent chevron">
                            <img src="@/assets/img/icons/primary/chevron-down.svg" height="24" width="24" />
                        </button>
                    </div>
                    <!-- raw material category name -->

                    <!-- raw material and quantity data -->
                    <b-collapse :id="rawMaterialCategoryObj.collapseCategoryName">
                        <div v-if="rawMaterialCategoryObj.categoryData.length"
                            class="new-border back rounded-10 col-12 p-2 mb-2">
                            <div class="table-scroll">
                                <table class="list-view-table text-center" v-if="!toCinema">
                                    <thead>
                                        <tr>
                                            <th class="text-left">Raw Material</th>
                                            <th class="text-left">Store Name</th>
                                            <th class="text-left">System Stock</th>
                                            <th class="text-center">Transfer Quantity</th>
                                            <th class="text-left">UOM Unit</th>
                                        </tr>
                                    </thead>
                                    <tr v-for="(rawMaterialObj, rawMaterialIndex) in rawMaterialCategoryObj.categoryData"
                                        :key="rawMaterialIndex + 'rawMaterial'">
                                        <td class="font-weight-bold text-left">{{ rawMaterialObj.rm_name }}</td>
                                        <td class="text-left p-2">{{ selectedStore.sm_store_name }}</td>
                                        <td class="text-left p-2">{{ rawMaterialObj.stockQuantity }} {{
                                            rawMaterialObj.uom_short_form }}
                                        </td>
                                        <td class="p-2 text-center">
                                            <div class="input-material w-50">
                                                <input v-model="rawMaterialObj.transfer_quantity"
                                                    name="transfer-quantity"
                                                    :id="'transfer-quantity' + rawMaterialObj.rm_id" placeholder="."
                                                    @blur="validateRawMaterialQuantity($event, rawMaterialCategoryIndex, rawMaterialIndex)" />
                                            </div>
                                        </td>
                                        <td class="text-left p-2">{{ rawMaterialObj.uom_unit }}</td>
                                    </tr>
                                </table>
                                <table class="list-view-table text-center transfer-stock-v2-table" v-if="toCinema">
                                    <thead>
                                        <tr>
                                            <th class="text-left">Raw Material</th>
                                            <th class="text-left">Store Name</th>
                                            <th class="text-right">System Stock</th>
                                            <th class="text-center">Transfer Quantity</th>
                                            <th class="text-center">Rate Per Item</th>
                                            <th class="text-center">Tax %</th>
                                            <th class="text-center">Tax Amount</th>
                                            <th class="text-center">Total</th>
                                            <th class="text-left">UOM Unit</th>
                                        </tr>
                                    </thead>
                                    <tr v-for="(rawMaterialObj, rawMaterialIndex) in rawMaterialCategoryObj.categoryData"
                                        :key="rawMaterialIndex + 'rawMaterial'">
                                        <td class="font-weight-bold text-left rm_text">{{ rawMaterialObj.rm_name }}
                                        </td>
                                        <td class="text-left p-2">{{ selectedStore.sm_store_name }}</td>
                                        <td class="text-right p-2">{{ rawMaterialObj.stockQuantity }} {{
                                            rawMaterialObj.uom_short_form }}
                                        </td>
                                        <td class="p-2 text-center">
                                            <div class="input-material w-50 mx-auto">
                                                <input v-model="rawMaterialObj.transfer_quantity"
                                                    name="transfer-quantity"
                                                    :id="'transfer-quantity' + rawMaterialObj.rm_id" placeholder="."
                                                    @blur="validateRawMaterialQuantity($event, rawMaterialCategoryIndex, rawMaterialIndex)" />
                                            </div>
                                        </td>
                                        <td class="p-2 text-center">
                                            <div class="input-material w-100 mx-auto">
                                                <input v-model="rawMaterialObj.adjustment_rate" name="adjustment-rate"
                                                    :id="'adjustment-rate' + rawMaterialObj.rm_id" placeholder=""
                                                    v-validate="{ required: toCinema, decimal: true }"
                                                    @blur="calculateNetAmount($event)" />
                                            </div>
                                        </td>
                                        <td class="p-2 text-center">
                                            <div class="input-material w-100 mx-auto">
                                                <input v-model="rawMaterialObj.adjustment_tax" name="adjustment-tax"
                                                    :id="'adjustment-tax' + rawMaterialObj.rm_id" placeholder=""
                                                    v-validate="{ required: toCinema, decimal: true }"
                                                    @blur="calculateNetAmount($event)" />
                                            </div>
                                        </td>
                                        <td class="p-2 text-center">
                                            <div class="input-material w-100 mx-auto">
                                                <input v-model="rawMaterialObj.poi_tax_amount"
                                                    name="adjustment-tax-amount"
                                                    :id="'adjustment-tax-amount' + rawMaterialObj.rm_id" placeholder=""
                                                    v-validate="{ required: toCinema, decimal: true }"
                                                    @blur="calculateNetAmount($event)" />
                                            </div>
                                        </td>
                                        <td class="p-2 text-center">
                                            <div class="input-material w-100 mx-auto">
                                                <input v-model="rawMaterialObj.poi_total_amount" name="total"
                                                    :id="'total' + rawMaterialObj.rm_id" placeholder=""
                                                    v-validate="{ required: toCinema, decimal: true }"
                                                    @blur="calculateNetAmount($event)" />
                                            </div>
                                        </td>
                                        <td class="text-left p-2">{{ rawMaterialObj.uom_unit }}</td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                    </b-collapse>
                    <!-- raw material and quantity data -->

                </section>
                <div class="col-md-12 text-center mt-4">
                    <button @click.prevent.stop="onFinalSubmit()" class="btn-blue">
                        Transfer
                    </button>
                    <!-- <button
            :disabled="btenable"
            @click.prevent.stop="onFinalSubmit(false)"
            class="btn-blue"
          >
            {{ $t("saveaddmore") }}
          </button> -->

                    <!-- <b-button class="btn-outline-grey" variant="default" to="fnb-wastage">{{ $t('cancel') }}</b-button> -->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import PosFnbService from "@/services/PosFnbService.js";
import MasterService from "@/services/MasterService.js";
import { Role, CLIENT_NAME } from "@/helper/Role";

import { groupBy } from "lodash";

export default {
    name: "TransferStocks",
    data() {
        return {
            dropDown: {
                cinemas: [],
                selectedCinema: null,
                selectedCinemaName: null,
                selectedCinemaId: "",
            },
            cinemaCopy: [],
            allStores: [],
            allStoresCinemaIds: [],
            storeList: [],
            toStoreList: [],
            toCinemaStoreList: [],
            toCinema: false,
            selectedStore: { sm_id: null },
            selectedToStore: { sm_id: null },
            selectedToCinema: { cine_id: null },
            selectedToCinemaStore: { sm_id: null },
            rawMaterialCategory: [],
            selectedRawMaterialCategory: [],
            rawMaterials: [],
            unitConversions: [],
            sectionCollapse: {}
        };
    },
    beforeMount() {
        let obj = this.secureStore.get("USINFO").cinema_id;
        let roleid = this.secureStore.get("USINFO").role_id;
        if (true) {
            this.isRoleID = false;
        }
        this.getCinemaList();
        this.getStores()
    },
    computed: {
        checkClientName() {
            console.log(this.CLIENT_SETUP_NAME);
            return CLIENT_NAME.EMPIRE == this.CLIENT_SETUP_NAME;
        },
        getCinemasByRole() {
            let cinemas = this.dropDown.cinemas;
            const { cinema_id } = this.secureStore.get("USINFO");
            if(cinema_id) {
                cinemas = cinemas.filter((cine) => cine.cine_id == cinema_id)
            }
            return cinemas
        },
        getFilteredCinemas() {
            let filteredToCinemas = JSON.parse(JSON.stringify(this.cinemaCopy));
            let cinemas_to_filter = []; // [...this.allStoresCinemaIds]

            if (this.dropDown.selectedCinemaId) {
                filteredToCinemas = filteredToCinemas.filter(cinemaObj => {
                    return cinemaObj.cine_id != this.dropDown.selectedCinemaId
                })
            }
            return filteredToCinemas;
        },
    },
    mounted() { },

    methods: {
        openCategory: function (collapseName) {
            let categoryCollapse = document.getElementById(collapseName)
            if (categoryCollapse.className == "collapse") {
                collapseName.classList = []
            } else {
                collapseName.classList = ["collapse"]
            }
        },
        getCinemaList: function () {
            MasterService.GetCinemas()
                .then((response) => {
                    const { data } = response;
                    if (data.status && data.Records.length > 0) {
                        this.dropDown.cinemas = data.Records;
                        this.cinemaCopy = data.Records;
                    } else {
                        this.$toasted.show(data.message);
                    }
                })
                .catch(this._CatchError);
        },
        onSelectCinema: async function (event) {
            this.dropDown.selectedCinema = event;
            this.dropDown.selectedCinemaName = event.cine_name;
            this.dropDown.selectedCinemaId = event.cine_id;
            this.$store.dispatch("selectDropdownCinema", event);
            await this.getCinemaStoreList()
        },
        getCinemaStoreList: async function () {
            try {
                const response = await MasterService.GetStoreManagement({ cine_id: this.dropDown.selectedCinemaId })
                const { data } = response
                if (data.status && data.Records.length) {
                    this.storeList = [...data.Records]
                }
            } catch (error) {
                console.log(error)
            }
        },
        getStores: async function () {
            try {
                const response = await PosFnbService.GetStores({})
                const { data } = response
                if (data.status && data.Records.length) {
                    this.allStores = [...data.Records]
                    this.allStoresCinemaIds = [
                        ...new Set(data.Records.map((s) => s.cinema_id)),
                    ].filter((x) => !!x);
                } else {
                    this.allStores = []
                }
            } catch (error) {
                console.log(error)
            }
        },
        getRawMaterialCategory: async function () {
            try {
                const response = await PosFnbService.getStoreRawMaterialQuantity({ type: "getCategory" })
                const { data } = response
                if (data.status && data.Records.length) {
                    this.rawMaterialCategory = [...data.Records]
                } else {
                    this.rawMaterialCategory = []
                }
            } catch (error) {
                console.log(error)
            }
        },
        onSelectStore: async function () {
            try {
                await this.getRawMaterialCategory();
                this.selectedToStore = { sm_id: null }
                this.toStoreList = this.storeList.filter(storeObj => {
                    return storeObj.sm_id != this.selectedStore.sm_id
                })
            } catch (error) {
                console.log(error)
            }
        },
        onSelectToCinema: function (event) {
            if (!event.cine_id) return this.selectedToCinema = { cine_id: null }


            if (!this.allStoresCinemaIds.includes(event.cine_id)) {
                this.$toasted.show("No store for cinema found")
                return this.selectedToCinema = { cine_id: null }
            }

            this.toCinemaStoreList = this.allStores.filter(storeObj => {
                return storeObj.cinema_id == event.cine_id
            })

        },
        onSelectCategory: function (type, event) {
            console.log({ type, event })
            if (type === "add") {
                let loader = this.$loading.show();
                if (!this.sectionCollapse.hasOwnProperty(`category-${event.rmc_category}`)) {
                    this.sectionCollapse[`category-${event.rmc_category}`] = false
                }

                PosFnbService.getStoreRawMaterialQuantity({
                    sm_id: this.selectedStore.sm_id, cinema_id: this.dropDown.selectedCinemaId, rmc_id: [event["rmc_id"]]
                }).then((response) => {
                    const { data } = response
                    if (data.status && data.Records.length) {
                        if (this.rawMaterials.length) {
                            this.rawMaterials = this.rawMaterials.concat(data.Records)
                            this.unitConversions = [...data.UnitMeasurementConversions]
                        } else {
                            this.rawMaterials = data.Records
                            this.unitConversions = data.UnitMeasurementConversions
                        }

                    } else {
                        this.rawMaterials = []
                        this.unitConversions = []
                    }
                    loader.hide()
                }).catch((error) => {
                    console.log(error)
                    this.$toasted.show("Something went wrong.");
                }).finally(() => {
                    loader && loader.hide();
                    this.$forceUpdate();
                });

            } else if (type == "remove") {
                console.log({ event })
                let loader = this.$loading.show();

                this.rawMaterials = this.rawMaterials.filter(rawMaterialObj => {
                    return rawMaterialObj.rmc_id != event.rmc_id
                })
                if (this.sectionCollapse.hasOwnProperty(`category-${event.rmc_category}`)) {
                    delete this.sectionCollapse[`category-${event.rmc_category}`]
                }

                loader.hide()

            }
        },
        calculateNetAmount: function (item) {
            // price = rate * qty
            // tax = (price * tax_percent) / 100
            // total_amount - price + tatx amount

            if (item.adjustment_rate && item.transfer_quantity) {
                item.poi_price = +parseFloat(
                    item.adjustment_rate * item.transfer_quantity
                ).toFixed(this.MIN_FRACTION_DIGITS);
            }

            if (item.poi_price && item.adjustment_tax) {
                item.poi_tax_amount = +parseFloat(
                    (item.poi_price * item.adjustment_tax) / 100
                ).toFixed(this.MIN_FRACTION_DIGITS);
            }

            if (item.poi_price && item.poi_tax_amount) {
                item.poi_total_amount = +parseFloat(
                    item.poi_price + item.poi_tax_amount
                ).toFixed(this.MIN_FRACTION_DIGITS);
            }

            this.$forceUpdate();

            console.log({ item });
        },
        validateRawMaterialQuantity: function (event, rawMaterialCategoryIndex, rawMaterialIndex) {
            console.log({ event, rawMaterialCategoryIndex, rawMaterialIndex })
            let inputValue = +parseFloat(event.target.value)
            if (inputValue > this.rawMaterials[rawMaterialCategoryIndex]["categoryData"][rawMaterialIndex]["stockQuantity"]) {
                this.rawMaterials[rawMaterialCategoryIndex]["categoryData"][rawMaterialIndex]["transfer_quantity"] = this.rawMaterials[rawMaterialCategoryIndex]["categoryData"][rawMaterialIndex]["stockQuantity"]
                this.calculateNetAmount(this.rawMaterials[rawMaterialCategoryIndex]["categoryData"][rawMaterialIndex])
                this.$toasted.show("Exceeds max transfer quantity")
            } else {
                if (this.rawMaterials[rawMaterialCategoryIndex]["categoryData"][rawMaterialIndex]["conversion_formula"] == 1 && String(inputValue).includes(".")) {
                    this.$toasted.show(
                        "Invalid value, Quantity should be number without decimal point"
                    );
                    this.rawMaterials[rawMaterialCategoryIndex]["categoryData"][rawMaterialIndex]["transfer_quantity"] = 0
                } else {
                    this.rawMaterials[rawMaterialCategoryIndex]["categoryData"][rawMaterialIndex]["transfer_quantity"] = inputValue
                    this.calculateNetAmount(this.rawMaterials[rawMaterialCategoryIndex]["categoryData"][rawMaterialIndex])
                }
            }
        },
        onFinalSubmit: async function () {
            try {
                if (!this.selectedToStore.sm_id && !this.toCinema) {
                    return this.$toasted.show("To store is missing")
                }

                if (this.toCinema && !this.selectedToCinema.cine_id) {
                    return this.$toasted.show("To cinema is missing")
                }

                if (this.toCinema && !this.selectedToCinemaStore.sm_id) {
                    return this.$toasted.show("To store of cinema is missing")
                }

                if (!this.selectedStore.sm_id) {
                    return this.$toasted.show("From store is missing")
                }

                if (!this.rawMaterials.length) {
                    return this.$toasted.show("No raw materials found")
                }

                let loader = this.$loading.show();

                let selectedRawMaterials = []
                this.rawMaterials.forEach(categoryObj => {
                    let filteredRawMaterials = categoryObj.categoryData.filter(rawMaterialObj => {
                        return rawMaterialObj.transfer_quantity > 0
                    })

                    if (filteredRawMaterials.length) {
                        filteredRawMaterials.forEach(filteredRawMaterialsObj => {
                            let obj = {
                                "rm_name": filteredRawMaterialsObj.rm_name,
                                "rm_id": filteredRawMaterialsObj.rm_id,
                                "stockQuantity": filteredRawMaterialsObj.stockQuantity,
                                "transfer_quantity": filteredRawMaterialsObj.transfer_quantity,
                                "stock_id": filteredRawMaterialsObj.stock_id,
                                "uom_units": filteredRawMaterialsObj.uom_units,
                                "uom_name": filteredRawMaterialsObj.uom_unit,
                                "conversion_formula": filteredRawMaterialsObj.conversion_formula,
                                "uom_id": filteredRawMaterialsObj.uom_id,
                                "adjustment_rate": filteredRawMaterialsObj.adjustment_rate,
                                "adjustment_tax": filteredRawMaterialsObj.adjustment_tax,
                                "poi_price": filteredRawMaterialsObj.poi_price,
                                "poi_tax_amount": filteredRawMaterialsObj.poi_tax_amount,
                                "poi_total_amount": filteredRawMaterialsObj.poi_total_amount,
                            }
                            selectedRawMaterials.push(obj)
                        })
                    }
                })

                const payload = {
                    cinema_id: this.dropDown.selectedCinemaId,
                    selectedRawMaterials: selectedRawMaterials,
                    transfer_from_store_management_id: this.selectedStore.sm_id,
                    transfer_to_store_management_id: this.toCinema ? this.selectedToCinemaStore.sm_id : this.selectedToStore.sm_id
                }

                if (this.toCinema) {
                    payload["to_cinema_id"] = this.selectedToCinema.cine_id
                }

                console.log(payload)

                const response = await PosFnbService.TransferStock(payload)
                const { data } = response
                if (data.status) {
                    this.$router.push({
                        path: "transfer-stocks-logs",
                    });
                } else {
                    this.$toasted.show(data.message)
                }
                loader.hide()
            } catch (error) {
                console.log(error)
            }
        }
    }
};
</script>

<style scoped>
.rm_text {
    white-space: break-spaces;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/FoodAndBeveragesContainer/TransferStocks/transferStocksV2.vue